<!-- <style>
  .card-header-formatting {
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: #EAEAEA;
  }

  .center {
    margin: auto;
    padding: 10px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .center-button {
    margin: auto;
    padding-top: 300px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .right {
    margin: auto;
    float: right;
    padding: 10px;
    padding-left: 20px;
  }

  .left {
    margin: auto;
    float: left;
    padding: 10px;
    padding-left: 25px;
  }

</style>
<div class="center">
  <fadv-grid>
    <fadv-grid-row>
      <fadv-grid-col style="padding-bottom: 25px">
        <fadv-typography style="text-align: center" type="heading-large" variant="primary">Welcome to First Advantage {{this.firstName}}!!</fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col>
        <fadv-typography style="text-align: center"><fadv-icon library='solid' name='handshake' label='Bell Icon' size='xxx-large' foreground='primary'></fadv-icon></fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col style="padding-top: 10px">
        <div class="center">
          <fadv-button style="padding-top: 50x; padding-bottom: 16px; width: 200px;" [block]="true" variant="primary"
            (click)="nextStep()" type="button">Login Now</fadv-button>
        </div>
      </fadv-grid-col>
    </fadv-grid-row>

  <fadv-grid-row>
    <fadv-grid-col [col]="4" [offset]="2">
      <div class="left" style="padding-bottom: 30px;">
        <fadv-typography style="text-align: center"><fadv-icon library='solid' name='envelope-circle-check' label='Bell Icon' size='xx-large' foreground="primary"></fadv-icon></fadv-typography>
        <fadv-typography style="text-align: center" type="paragraph-medium" variant="neutral">Keep an eye out for additional communications related to your business verification.</fadv-typography>
      </div>
    </fadv-grid-col>
    <fadv-grid-col style="padding-top: 20px" [col]="4">    
  <div class="right" style="padding-bottom: 30px;">
    <fadv-typography style="text-align: center"><fadv-icon library='solid' name='circle-question' label='Bell Icon' size='x-large' foreground="primary"></fadv-icon></fadv-typography>
    <fadv-typography style="text-align: center" type="paragraph-medium" variant="neutral">Check out our new <a href="placeholder">Help Center.</a> This wealth of information includes answers to your questions and will guide you through the background check process. </fadv-typography>
  </div>
    </fadv-grid-col>
  </fadv-grid-row>
</fadv-grid> -->

<div class="center">
  <fadv-grid>
    <fadv-grid-row>
      <fadv-grid-col style="padding-bottom: 25px">
        <fadv-typography id="typography1" type="{{ welcomeSize }}" variant="primary">Welcome to First Advantage {{this.firstName}}!!</fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col>
        <fadv-typography id="typography2"><fadv-icon library='solid' name='handshake' label='Bell Icon' size='xxx-large' foreground='primary'></fadv-icon></fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-col *ngIf="displayTestToken">
      <fadv-grid-row>
        <fadv-typography id="testTokenTypography">{{this.testToken}}</fadv-typography>
      </fadv-grid-row>
    </fadv-grid-col>
    <fadv-grid-row>
      <fadv-grid-col>
        <fadv-typography id="typography3" type="{{ copyTextSize }}" variant="neutral">Your account has been created.</fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col [offset]="{ xs: 0, s: 1, lg: 4 }" [col]="{ lg: 4, xs: 12 }" style="padding-top: 12px">
        <fadv-typography id="typography4" type="{{ copyTextSize }}" variant="neutral">Keep an eye out for additional communications related to your business verification.</fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col style="padding-top: 10px">
        <div class="center">
          <fadv-button style="padding-top: 50x; padding-bottom: 16px; width: 200px;" [block]="true" variant="primary"
            (click)="nextStep()" type="button" name="credentialing-login-button">Login Now</fadv-button>
        </div>
      </fadv-grid-col>
    </fadv-grid-row>
    
  <fadv-grid-row>
    <fadv-grid-col style="padding-top: 20px" [offset]="{ xs: 0, s: 1, lg: 4 }" [col]="{ lg: 4, xs: 12 }">    
  <div style="padding-bottom: 30px;">
    <fadv-typography  id="helpCenterTypography" type="paragraph-medium" variant="neutral">Check out our new <a href="https://fadv.com/smallbusiness/support/" target="_new">Help Center.</a> This wealth of information includes answers to your questions and will guide you through the background check process. </fadv-typography>
  </div>
    </fadv-grid-col>
  </fadv-grid-row>
</fadv-grid>
